import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      name: 'home',
      meta: {
        title: '江苏省企业信息化协会',
      },
      component: () =>
        import( /* webpackChunkName: "index" */ './views/index.vue'),
    },
    {
      path: '/aboutUS',
      name: 'aboutUS',
      component: () =>
        import( /* webpackChunkName: "about-us" */ './views/aboutUS.vue'),
      meta: {
        title: '关于我们',
      },
    },
    {
      path: '/policyKnow',
      name: 'policyKnow',
      component: () =>
        import( /* webpackChunkName: "policy-know" */ './views/policyKnow.vue'),
      meta: {
        title: '政知道',
      },
    },
    {
      path: '/member',
      redirect: '/member/apply',
    },
    {
      path: '/member/apply',
      component: () =>
        import(
          /* webpackChunkName: "member-apply" */
          './views/member/apply.vue'
        ),
      meta: {
        title: '会员申请',
      },
    },
    {
      path: '/member/apply/wait',
      component: () =>
        import(
          /* webpackChunkName: "member-apply-wait" */
          './views/member/wait.vue'
        ),
      meta: {
        title: '等待审核',
      },
    },
    {
      path: '/member/apply/wait2pay',
      component: () =>
        import(
          /* webpackChunkName: "member-apply-wait2pay" */
          './views/member/wait2pay.vue'
        ),
      meta: {
        title: '待付款',
      },
    },
    {
      path: '/member/apply/audit-fail',
      component: () =>
        import(
          /* webpackChunkName: "member-apply-audit-fail" */
          './views/member/auditFair.vue'
        ),
      meta: {
        title: '审核失败',
      },
    },
    {
      path: '/member/apply/audit-success',
      component: () =>
        import(
          /* webpackChunkName: "member-apply-audit-success" */
          './views/member/auditSuccess.vue'
        ),
      meta: {
        title: '审核成功',
      },
    },
    {
      path: '/member/apply/finish',
      component: () =>
        import(
          /* webpackChunkName: "member-apply-audit-success" */
          './views/member/applyFinish.vue'
        ),
      meta: {
        title: '申请完成',
      },
    },
    {
      path: '/member/pay',
      redirect: '/member/apply/wai2pay',
    },
    {
      path: '/member/pay/success',
      component: () =>
        import(
          /* webpackChunkName: "member-apply-pay-success" */
          './views/member/paySuccess.vue'
        ),
      meta: {
        title: '付款完成',
      },
    },
    {
      path: '/member/pay/remit-confirm',
      name: 'member-pay-remit-confirm',
      component: () =>
        import(
          /* webpackChunkName: "member-apply-remit-confirm" */
          './views/member/remitConfirm.vue'
        ),
      meta: {
        title: '线下汇款确认',
      },
    },
    {
      path: '/member/pay/online',
      component: () =>
        import( /* webpackChunkName: "index" */ './views/member/onLinePay.vue'),
      name: 'onLinePay',
      meta: {
        title: '线上支付',
      },
    },
    {
      path: '/member/pay/offline',
      component: () =>
        import(
          /* webpackChunkName: "member-pay-offline" */
          './views/member/offLinePay.vue'
        ),
      name: 'offLinePay',
      meta: {
        title: '线下支付',
      },
    },

    {
      path: '/activity/activityList',
      name: 'activityList',
      component: () =>
        import(
          /* webpackChunkName: "activity-list" */
          './views/activity/activityList.vue'
        ),
      meta: {
        title: '活动列表',
      },
    },
    {
      path: '/activity/list',
      name: 'activity-list',
      component: () =>
        import(
          /* webpackChunkName: "activity-list-2" */
          './views/activity/activityList.vue'
        ),
      meta: {
        title: '活动列表',
      },
    },
    {
      path: '/activity/activityDetails',
      component: () =>
        import(
          /* webpackChunkName: "activity-detail" */
          './views/activity/activityDetails.vue'
        ),
      name: 'activityDetails',
      meta: {
        title: '活动详情',
      },
    },
    {
      path: '/activity/detail/:id',
      component: () =>
        import(
          /* webpackChunkName: "activity-detail" */
          './views/activity/activityDetails.vue'
        ),
      name: 'activity-detail',
      meta: {
        title: '活动详情',
      },
    },
    {
      path: '/activity/signup/basic',
      component: () =>
        import(
          /* webpackChunkName: "activity-signup-basic" */
          './views/activity/basicInfo.vue'
        ),
      name: 'activity-signup-basic',
      meta: {
        title: '基本信息确认',
      },
    },
    {
      path: '/activity/signup/form',
      name: 'activity-signup-form',
      component: () =>
        import(
          /* webpackChunkName: "activity-signup-form" */
          './views/activity/formElements.vue'
        ),
      meta: {
        title: '填写报名表单',
      },
    },
    {
      path: '/activity/signup/success',
      name: 'activity-signup-success',
      component: () =>
        import(
          /* webpackChunkName: "activity-signup-success" */
          './views/activity/success.vue'
        ),
      meta: {
        title: '报名成功',
      },
    },
    {
      path: '/activity/signup/fail',
      name: 'activity-signup-fail',
      component: () =>
        import(
          /* webpackChunkName: "activity-signup-fail" */
          './views/activity/fair.vue'
        ),
      meta: {
        title: '报名失败',
      },
    },
    {
      path: '/mine',
      component: () =>
        import( /* webpackChunkName: "mine" */ './views/mine.vue'),
      name: 'mine',
      meta: {
        title: '个人中心',
      },
    },
    {
      path: '/mine/ticket',
      component: () =>
        import(
          /* webpackChunkName: "mine-ticket" */
          './views/mine/ticket.vue'
        ),
      name: 'my-ticket',
      meta: {
        title: '电子票',
      },
    },
    {
      path: '/mine/activity',
      component: () =>
        import(
          /* webpackChunkName: "mine-activity" */
          './views/mine/myActivity.vue'
        ),
      name: 'my-activity',
      meta: {
        title: '我的活动',
      },
    },
    {
      path: '/mine/qrcode',
      component: () =>
        import(
          /* webpackChunkName: "mine-qrcode" */
          './views/mine/myQRcode.vue'
        ),
      name: 'my-qrcode',
      meta: {
        title: '我的二维码',
      },
    },
    {
      path: '/mine/info',
      component: () =>
        import( /* webpackChunkName: "mine-info" */ './views/mine/myInfo.vue'),
      name: 'my-info',
      meta: {
        title: '我的信息',
      },
    },
    {
      path: '/mine/collect',
      component: () =>
        import(
          /* webpackChunkName: "my-collect" */
          './views/mine/myCollect.vue'
        ),
      name: 'my-collect',
      redirect: {
        name: 'my-collect-activity'
      },
      meta: {
        title: '我的收藏',
      },
      children: [{
          path: 'activity',
          component: () =>
            import(
              /* webpackChunkName: "my-collect-activity" */
              './views/mine/collectActivity.vue'
            ),
          name: 'my-collect-activity',
          meta: {
            title: '我的收藏-活动',
          },
        },
        {
          path: 'news',
          component: () =>
            import(
              /* webpackChunkName: "my-collect-news" */
              './views/mine/collectNews.vue'
            ),
          name: 'my-collect-news',
          meta: {
            title: '我的收藏-新闻',
          },
        },
        {
          path: 'policy',
          component: () =>
            import(
              /* webpackChunkName: "my-collect-policy" */
              './views/mine/collectPolicy.vue'
            ),
          name: 'my-collect-policy',
          meta: {
            title: '我的收藏',
          },
        },
        {
          path: 'video',
          component: () =>
            import(
              /* webpackChunkName: "my-collect-video" */
              './views/mine/collectVideo.vue'
            ),
          name: 'my-collect-video',
          meta: {
            title: '我的收藏-视频',
          },
        },
        {
          path: 'project',
          component: () =>
            import(
              /* webpackChunkName: "my-collect-project" */
              './views/mine/collectProject.vue'
            ),
          name: 'my-collect-project',
          meta: {
            title: '我的收藏-项目',
          },
        },
      ],
    },

    {
      path: '/state/developing',
      name: 'developing',
      component: () =>
        import(
          /* webpackChunkName: "developing" */
          './views/statePage/developing.vue'
        ),
      meta: {
        title: '开发中',
      },
    },
    {
      path: '/state/error',
      component: () =>
        import( /* webpackChunkName: "error" */ './views/statePage/error.vue'),
      meta: {
        title: '出错啦',
      },
    },

    {
      path: '/news/newsList',
      component: () =>
        import(
          /* webpackChunkName: "news-list" */
          './views/news/newsList.vue'
        ),
      name: 'newsList',
      meta: {
        title: '新闻列表',
      },
    },
    {
      path: '/news/list',
      component: () =>
        import(
          /* webpackChunkName: "news-list-2" */
          './views/news/newsList.vue'
        ),
      name: 'news-list',
      meta: {
        title: '新闻列表',
      },
    },
    {
      path: '/news/newsDetails',
      component: () =>
        import(
          /* webpackChunkName: "news-detail" */
          './views/news/newsDetails.vue'
        ),
      name: 'newsDetails',
      meta: {
        title: '新闻详情',
      },
    },
    {
      path: '/news/detail/:id',
      component: () =>
        import(
          /* webpackChunkName: "news-detail-2" */
          './views/news/newsDetails.vue'
        ),
      name: 'news-detail',
      meta: {
        title: '新闻详情',
      },
    },

    {
      path: '/study/studyList',
      component: () =>
        import(
          /* webpackChunkName: "study-list" */
          './views/study/studyList.vue'
        ),
      name: 'studyList',
      meta: {
        title: '研习社',
      },
    },
    {
      path: '/study/list',
      component: () =>
        import(
          /* webpackChunkName: "study-list" */
          './views/study/studyList.vue'
        ),
      name: 'study-list',
      meta: {
        title: '研习社',
      },
    },
    {
      path: '/study/studyDetails',
      component: () =>
        import(
          /* webpackChunkName: "study-detail" */
          './views/study/studyDetails.vue'
        ),
      name: 'studyDetails',
      meta: {
        title: '研习社详情',
      },
    },
    {
      path: '/study/detail/:id',
      component: () =>
        import(
          /* webpackChunkName: "study-detail" */
          './views/study/studyDetails.vue'
        ),
      name: 'study-detail',
      meta: {
        title: '研习社详情',
      },
    },
    {
      path: '/shop/shopList',
      component: () =>
        import(
          /* webpackChunkName: "shop-list" */
          './views/shop/shopList.vue'
        ),
      name: 'shopList',
      meta: {
        title: '战疫产品',
      },
    },
    {
      path: '/shop/list',
      component: () =>
        import(
          /* webpackChunkName: "shop-list" */
          './views/shop/shopList.vue'
        ),
      name: 'shop-list',
      meta: {
        title: '战疫产品',
      },
    },
    {
      path: '/shop/shopDetails',
      component: () =>
        import(
          /* webpackChunkName: "shop-detail" */
          './views/shop/shopDetails.vue'
        ),
      name: 'shopDetails',
      meta: {
        title: '战疫产品详情',
      },
    },
    {
      path: '/shop/detail/:id',
      component: () =>
        import(
          /* webpackChunkName: "shop-detail" */
          './views/shop/shopDetails.vue'
        ),
      name: 'shop-detail',
      meta: {
        title: '战疫产品详情',
      },
    },
    {
      path: '/account/bindMobile',
      component: () =>
        import(
          /* webpackChunkName: "account-bind-mobile" */
          './views/account/BindMobile.vue'
        ),
      name: 'BindMobile',
      meta: {
        title: '绑定手机号',
      },
    },
    {
      path: '/account/login',
      component: () =>
        import(
          /* webpackChunkName: "accout-login" */
          './views/account/login.vue'
        ),
      name: 'login',
      meta: {
        title: '登录',
      },
    },
    {
      path: '/account/register',
      component: () =>
        import(
          /* webpackChunkName: "account-register" */
          './views/account/register.vue'
        ),
      name: 'register',
      meta: {
        title: '注册',
      },
    },
    {
      path: '/account/forgetPassword',
      component: () =>
        import(
          /* webpackChunkName: "account-fogotpassword" */
          './views/account/forgetPassword.vue'
        ),
      name: 'forgetPassword',
      meta: {
        title: '忘记密码',
      },
    },
    {
      path: '/transferLogin',
      component: () =>
        import(
          /* webpackChunkName: "index" */
          './views/account/transferLogin.vue'
        ),
      name: 'transferLogin',
      meta: {
        title: '登录转换',
      },
    },
    {
      path: '/wxcallback',
      component: () =>
        import( /* webpackChunkName: "index" */ './views/wxcallback.vue'),
      name: 'wxcallback',
      meta: {
        title: '微信回调',
      },
    },
    {
      path: '/serviceSystem/:categoryNo',
      component: () =>
        import(
          /* webpackChunkName: "service-system-category" */
          './views/cmsCategory/categoryDetail.vue'
        ),
      name: 'serviceSystemChildCategory',
      meta: {
        title: '服务体系',
      },
    },
    {
      path: '/serviceSystem/news/:category',
      component: () =>
        import(
          /* webpackChunkName: "service-system-list" */
          './views/news/newsList.vue'
        ),
      name: 'serviceSystemNews',
      meta: {
        title: '新闻列表',
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  var u = navigator.userAgent;
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  // XXX: 修复iOS版微信HTML5 History兼容性问题
  if (isiOS && to.path !== location.pathname) {
    // 此处不可使用location.replace
    location.assign(to.fullPath)
  } else {
    next()
  }
});

export default router
